import "components/ui/Loader/Loader.scss";
import PropTypes from 'prop-types';
import Trans from "features/translation/components/Trans";
import { useRef, useState } from "react";
import { CSSTransition } from "react-transition-group";

function Loader({ containerVariant, loaderVariant }) {
  const timer = useRef();
  const [ visible, setVisible ] = useState(false);

  timer.current = setTimeout(
    () => {
      setVisible(true)
    },
    150);

  return (
    <CSSTransition
      in={ visible }
      timeout={ 150 }
      classNames="loader-animate-"
      unmountOnExit>
      <div className={ `loader-container--${ containerVariant }` }>
        <div className={ 'loader-container__inner' }>
          <div className={ `loader loader--${ loaderVariant }` }>
            <Trans text={ 'Even geduld alstublieft...' }/>
          </div>
        </div>
      </div>
    </CSSTransition>
  );
}

Loader.propTypes = {
  containerVariant: PropTypes.string,
  loaderVariant: PropTypes.string,
}

export default Loader;
